import React, { useEffect, useState } from 'react';
import './Formulario.css';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';
import BotaoVoltarTopo from '../components/BotaoVoltarTopo';

const _authHeaders = (extra = {}) => {
  const token = getAuthToken();
  const h = { ...extra };
  if (token) h['Authorization'] = 'Bearer ' + token;
  return h;
};

export default function FormularioContrato({ contrato, onSalvar, onCancelar, onContratoAtualizado }) {
  const buildStateFromContrato = (c) => ({

    OrcamentosId: c?.orcamentosId ?? c?.OrcamentosId ?? '',
    Id_cliente: c?.id_cliente ?? c?.Id_cliente ?? '',
    VendaId: c?.vendaId ?? c?.VendaId ?? '',
    Data_assinatura: c?.data_assinatura ?? c?.Data_assinatura ?? '',
    DataVigencia: c?.dataVigencia ?? c?.DataVigencia ?? '',
    Status: c?.status ?? c?.Status ?? 'Pendente Assinatura',
    Valor: c?.valor ?? c?.Valor ?? '',
    DescontoAdicional: c?.descontoAdicional ?? c?.DescontoAdicional ?? '',
    DataCriacao: c?.dataCriacao ?? c?.DataCriacao ?? '',
    Prazo_garantia: c?.prazo_garantia ?? c?.Prazo_garantia ?? '',
    DescricaoOrcamento: c?.descricaoOrcamento ?? c?.DescricaoOrcamento ?? '',
    CondicoesPagto: c?.condicoesPagto ?? c?.CondicoesPagto ?? '',
    ServicosContratados: c?.servicosContratados ?? c?.ServicosContratados ?? ''
  });

  const [form, setForm] = useState(buildStateFromContrato(contrato));
  const [statusAnterior, setStatusAnterior] = useState(form.Status);

  // Sincroniza quando o contrato recebido via props mudar
  useEffect(() => {
    setForm(buildStateFromContrato(contrato));
    const contratoId = contrato?.id || contrato?.Id;
    // manter o status anterior conforme veio do banco
    setStatusAnterior(buildStateFromContrato(contrato).Status);
    if (contratoId) {
      buscarAditivos(contratoId);
    }
  }, [contrato]);

  const [salvando, setSalvando] = useState(false);
  const [error, setError] = useState('');
  const [assinarLoading, setAssinarLoading] = useState(false);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [assinaturaResult, setAssinaturaResult] = useState(null);
  const [mostrarAditivo, setMostrarAditivo] = useState(false);
  const [aditivoForm, setAditivoForm] = useState({
    tipoAditivo: 'Valor',
    valorAdicional: '',
    descontoAdicional: '',
    diasAdicionais: '',
    alteracaoEscopo: '',
    justificativa: '',
    observacoesInternas: '',
    observacoesCliente: ''
  });
  const [valoresCalculadosAditivo, setValoresCalculadosAditivo] = useState({
    valorFinal: 0,
    percentualAlteracao: 0,
    novoPrazoFinal: null
  });
  const [aditivos, setAditivos] = useState([]);
  const [openAditivos, setOpenAditivos] = useState([]); // múltiplos formulários abertos
  const [carregandoAditivos, setCarregandoAditivos] = useState(false);
  const [aditivoEditando, setAditivoEditando] = useState(null);
  const [pendingAditivos, setPendingAditivos] = useState([]);
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [contratoSalvoId, setContratoSalvoId] = useState(null);
  const [statusPopup, setStatusPopup] = useState(null); // { type: 'success'|'info'|'error', title, text }

  // Status disponíveis para contrato
  const statusDisponiveis = [
    'Pendente Assinatura',
    'Assinado',
    'Cancelado'
  ];

  const wasSignedBefore = statusAnterior === 'Assinado';

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  }

  async function handleAssinarContrato() {
    const contratoId = contrato?.id || contrato?.Id;
    if (!contratoId) {
      alert('Salve o contrato antes de enviar para assinatura.');
      return;
    }
    setAssinarLoading(true);
    setAssinaturaResult(null);
    // Abre a aba já no clique (depois do "await" o navegador bloquearia como pop-up); o link entra quando chegar
    const aba = window.open('', '_blank');
    if (aba) {
      aba.document.write('<p style="font-family:Arial,sans-serif;padding:24px;color:#555">Gerando o link de assinatura...</p>');
    }
    const urls = [
      `${BASE_URL}/Assinatura/enviar`,
      `${BASE_URL}/Assinatura/enviar`,
      `${BASE_URL}/Assinatura/enviar`,
      `${BASE_URL}/Assinatura/enviar`,
      `${BASE_URL}/Assinatura/enviar`
    ];
    let resultado = null;
    for (const url of urls) {
      try {
        const resp = await fetch(url, {
          method: 'POST',
          headers: _authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify({ contratoId: parseInt(contratoId), metodoAssinatura: 'virtual' })
        });
        if (resp.ok) {
          resultado = await resp.json();
          break;
        }
      } catch (e) { continue; }
    }
    setAssinarLoading(false);
    const link = (resultado?.signatarios || []).map(s => s.urlAssinatura).find(Boolean);
    if (!resultado || !resultado.sucesso || !link) {
      if (aba) aba.close();
      alert('Erro ao gerar a assinatura: ' + (resultado?.mensagem || 'link de assinatura não disponível.'));
      return;
    }
    if (aba) {
      aba.opener = null;
      aba.location.href = link;
    } else {
      // Navegador bloqueou a nova aba: mostra um botão para abrir
      setAssinaturaResult({ ...resultado, link });
      setShowLinkModal(true);
    }
  }

  async function handleRefreshStatus() {
    const contratoId = contrato?.id || contrato?.Id;
    if (!contratoId) return;
    setRefreshLoading(true);
    const urls = [
      `${BASE_URL}/Assinatura/status/${contratoId}`,
      `${BASE_URL}/Assinatura/status/${contratoId}`,
      `${BASE_URL}/Assinatura/status/${contratoId}`,
      `${BASE_URL}/Assinatura/status/${contratoId}`,
      `${BASE_URL}/Assinatura/status/${contratoId}`
    ];
    let statusData = null;
    for (const url of urls) {
      try {
        const resp = await fetch(url, { headers: _authHeaders() });
        if (resp.ok) { statusData = await resp.json(); break; }
      } catch (e) { continue; }
    }
    setRefreshLoading(false);
    if (!statusData) {
      setStatusPopup({ type: 'error', title: 'Erro', text: 'Não foi possível consultar o status da assinatura. Verifique o backend.' });
      return;
    }
    const statusAssinado = ['signed', 'certified', 'certificated'].includes((statusData.status || '').toLowerCase());
    const novoStatus = statusAssinado ? 'Assinado' : 'Pendente Assinatura';
    setForm(f => {
      const atualizado = { ...f, Status: novoStatus };
      if (onContratoAtualizado) {
        onContratoAtualizado(atualizado);
      }
      return atualizado;
    });
    if (statusAssinado) {
      setStatusPopup({ type: 'success', title: '✅ Contrato assinado atualizado com sucesso', text: 'O contrato foi atualizado como assinado com sucesso.' });
    } else {
      setStatusPopup({ type: 'info', title: 'Aguardando assinatura', text: `Status atual: ${statusData.status || 'pendente'}. O cliente ainda não assinou o contrato.` });
    }
  }

  function handleAditivoChange(campo, valor) {
    setAditivoForm(prev => ({
      ...prev,
      [campo]: valor
    }));
  }

  function addAditivoInstance() {
    const novo = {
      _id: Date.now() + Math.random().toString(36).slice(2),
      tipoAditivo: 'Valor',
      valorAdicional: '',
      descontoAdicional: '',
      diasAdicionais: '',
      alteracaoEscopo: '',
      justificativa: '',
      observacoesInternas: '',
      observacoesCliente: ''
    };
    setOpenAditivos(prev => [...prev, novo]);
  }

  function removeAditivoInstance(id) {
    setOpenAditivos(prev => prev.filter(x => x._id !== id));
  }

  function handleAditivoInstanceChange(id, campo, valor) {
    setOpenAditivos(prev => prev.map(x => x._id === id ? { ...x, [campo]: valor } : x));
  }

  async function closeAditivoInstance(id) {
    const inst = openAditivos.find(x => x._id === id);
    if (!inst) return;

    // Se for edição de aditivo existente (originalId presente), salvar via PUT
    if (inst.originalId) {
      // Preencher o formulário de edição e delegar para salvarAditivo (que faz PUT se aditivoEditando estiver setado)
      setAditivoForm({
        tipoAditivo: inst.tipoAditivo || 'Valor',
        valorAdicional: inst.valorAdicional || '',
        descontoAdicional: inst.descontoAdicional || '',
        diasAdicionais: inst.diasAdicionais || '',
        alteracaoEscopo: inst.alteracaoEscopo || '',
        justificativa: inst.justificativa || '',
        observacoesInternas: inst.observacoesInternas || '',
        observacoesCliente: inst.observacoesCliente || ''
      });
      // Garantir que o estado de edição aponta para o aditivo correto
      // O objeto original (do servidor) já está em `aditivoEditando` quando abriu a instância via `editarAditivo`
      try {
        await salvarAditivo();
        // Se salvou, remover instância
        setOpenAditivos(prev => prev.filter(x => x._id !== id));
        setAditivoEditando(null);
      } catch (err) {
        // Em caso de falha, manter a instância aberta para correção
        setError(err.message || 'Falha ao atualizar aditivo.');
      }
      return;
    }

    // Caso padrão: novo aditivo — adicionar ao pending se justificativa válida
    if (inst.justificativa && inst.justificativa.trim().length >= 20) {
      const novo = {
        tipoAditivo: inst.tipoAditivo,
        valorAdicional: inst.valorAdicional ? parseFloat(inst.valorAdicional) : null,
        descontoAdicional: inst.descontoAdicional ? parseFloat(inst.descontoAdicional) : null,
        diasAdicionais: inst.diasAdicionais ? parseInt(inst.diasAdicionais) : null,
        alteracaoEscopo: inst.alteracaoEscopo || null,
        justificativa: inst.justificativa,
        observacoesInternas: inst.observacoesInternas || null,
        observacoesCliente: inst.observacoesCliente || null,
        _tempId: Date.now() + Math.random().toString(36).slice(2)
      };
      setPendingAditivos(prev => [...prev, novo]);
    }

    // Remove instância aberta
    setOpenAditivos(prev => prev.filter(x => x._id !== id));
  }

  async function buscarAditivos(contratoId) {
    console.log('🔍 Buscando aditivos para contrato ID:', contratoId);
    setCarregandoAditivos(true);
    try {
      const urls = [
        `${BASE_URL}/AditivoContratual/contrato/${contratoId}`,
        `${BASE_URL}/AditivoContratual/contrato/${contratoId}`,
        `${BASE_URL}/AditivoContratual/contrato/${contratoId}`,
        `${BASE_URL}/AditivoContratual/contrato/${contratoId}`,
        `${BASE_URL}/AditivoContratual/contrato/${contratoId}`
      ];

      for (const url of urls) {
        try {
          console.log('🔗 Tentando URL:', url);
          const response = await fetch(url, { headers: _authHeaders() });
          if (response.ok) {
            const data = await response.json();
            console.log('✅ Resposta recebida:', data);
            const aditivosArray = data.aditivos || data || [];
            console.log('📋 Array de aditivos:', aditivosArray);
            setAditivos(aditivosArray);
            break;
          } else {
            console.log('❌ Falha na URL:', url, 'Status:', response.status);
          }
        } catch (err) {
          console.log('❌ Erro na URL:', url, err.message);
          continue;
        }
      }
    } catch (err) {
      console.error('🛑 Erro ao buscar aditivos:', err);
    } finally {
      setCarregandoAditivos(false);
    }
  }

  useEffect(() => {
    if (mostrarAditivo && (aditivoForm.valorAdicional || aditivoForm.descontoAdicional)) {
      calcularValoresAditivo();
    }
  }, [aditivoForm.valorAdicional, aditivoForm.descontoAdicional, form.Valor]);

  useEffect(() => {
    if (mostrarAditivo && aditivoForm.diasAdicionais && form.DataVigencia) {
      calcularPrazoAditivo();
    }
  }, [aditivoForm.diasAdicionais, form.DataVigencia]);

  function calcularValoresAditivo() {
    const valorOriginal = parseFloat(form.Valor || 0);
    const valorAdd = parseFloat(aditivoForm.valorAdicional || 0);
    const desconto = parseFloat(aditivoForm.descontoAdicional || 0);
    const valorFinal = valorOriginal + valorAdd - desconto;
    const percentual = valorOriginal > 0 ? ((valorAdd - desconto) / valorOriginal) * 100 : 0;

    setValoresCalculadosAditivo(prev => ({
      ...prev,
      valorFinal,
      percentualAlteracao: percentual
    }));
  }

  function calcularPrazoAditivo() {
    if (!form.DataVigencia) return;
    const dias = parseInt(aditivoForm.diasAdicionais || 0);
    const data = new Date(form.DataVigencia);
    data.setDate(data.getDate() + dias);
    setValoresCalculadosAditivo(prev => ({
      ...prev,
      novoPrazoFinal: data
    }));
  }

  async function salvarAditivo() {
    if (!aditivoForm.justificativa.trim()) {
      setError('Justificativa é obrigatória para o aditivo.');
      return;
    }

    if (aditivoForm.justificativa.trim().length < 20) {
      setError('Justificativa deve ter pelo menos 20 caracteres.');
      return;
    }

    // If editing an existing aditivo from DB, save immediately (PUT)
    if (aditivoEditando && (aditivoEditando.id || aditivoEditando.Id)) {
      const aditivoId = aditivoEditando.id || aditivoEditando.Id;
      const payload = {
        TipoAditivo: aditivoForm.tipoAditivo,
        ValorAdicional: aditivoForm.valorAdicional ? parseFloat(aditivoForm.valorAdicional) : null,
        DiasAdicionais: aditivoForm.diasAdicionais ? parseInt(aditivoForm.diasAdicionais) : null,
        AlteracaoEscopo: aditivoForm.alteracaoEscopo || null,
        Justificativa: aditivoForm.justificativa,
        ObservacoesInternas: aditivoForm.observacoesInternas || null,
        ObservacoesCliente: aditivoForm.observacoesCliente || null
      };

      setSalvando(true);
      setError('');
      try {
        const urls = [
          `${BASE_URL}/AditivoContratual/${aditivoId}`,
          `${BASE_URL}/AditivoContratual/${aditivoId}`,
          `${BASE_URL}/AditivoContratual/${aditivoId}`,
          `${BASE_URL}/AditivoContratual/${aditivoId}`
        ];
        let updated = false;
        for (const url of urls) {
          try {
            const resp = await fetch(url, { method: 'PUT', headers: _authHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify(payload) });
            if (resp.ok) { updated = true; break; }
          } catch (e) { continue; }
        }
        if (updated) {
          setAditivoEditando(null);
          setAditivoForm({
            tipoAditivo: 'Valor', valorAdicional: '', descontoAdicional: '', diasAdicionais: '', alteracaoEscopo: '', justificativa: '', observacoesInternas: '', observacoesCliente: ''
          });
          const contratoId = contrato?.id || contrato?.Id;
          if (contratoId) await buscarAditivos(contratoId);
        } else {
          setError('Falha ao atualizar aditivo no servidor.');
        }
      } catch (err) {
        setError(`Erro ao atualizar aditivo: ${err.message}`);
      } finally {
        setSalvando(false);
      }
      return;
    }

    // Otherwise add to pending list (cart) to be posted when saving the contract
    const novo = {
      tipoAditivo: aditivoForm.tipoAditivo,
      valorAdicional: aditivoForm.valorAdicional ? parseFloat(aditivoForm.valorAdicional) : null,
      descontoAdicional: aditivoForm.descontoAdicional ? parseFloat(aditivoForm.descontoAdicional) : null,
      diasAdicionais: aditivoForm.diasAdicionais ? parseInt(aditivoForm.diasAdicionais) : null,
      alteracaoEscopo: aditivoForm.alteracaoEscopo || null,
      justificativa: aditivoForm.justificativa,
      observacoesInternas: aditivoForm.observacoesInternas || null,
      observacoesCliente: aditivoForm.observacoesCliente || null,
      _tempId: Date.now() + Math.random()
    };

    setPendingAditivos(prev => [...prev, novo]);
    setAditivoForm({
      tipoAditivo: 'Valor',
      valorAdicional: '',
      descontoAdicional: '',
      diasAdicionais: '',
      alteracaoEscopo: '',
      justificativa: '',
      observacoesInternas: '',
      observacoesCliente: ''
    });
    setMostrarAditivo(false);
  }

  // Valor do contrato = valor do orçamento − desconto adicional (o backend recalcula ao salvar)
  const descontoAdicionalSalvo = parseFloat(contrato?.descontoAdicional ?? contrato?.DescontoAdicional ?? 0) || 0;
  const valorBaseContrato = (parseFloat(contrato?.valor ?? contrato?.Valor ?? form.Valor ?? 0) || 0) + descontoAdicionalSalvo;
  const descontoAdicionalAtual = parseFloat(form.DescontoAdicional || 0) || 0;
  const descontoAdicionalInvalido = descontoAdicionalAtual < 0 || descontoAdicionalAtual > valorBaseContrato;
  const valorFinalContrato = Math.max(0, valorBaseContrato - descontoAdicionalAtual);
  const contratoAssinado = (contrato?.status ?? contrato?.Status) === 'Assinado';

  const formatarMoeda = (valor) => {
    if (!valor) return 'R$ 0,00';
    return `R$ ${parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const formatarData = (data) => {
    if (!data) return '';
    const d = new Date(data);
    return d.toLocaleDateString('pt-BR');
  };

  function editarAditivo(aditivo) {
    // Abrir uma instância do formulário para editar o aditivo existente
    setAditivoEditando(aditivo);
    const novo = {
      _id: Date.now() + Math.random().toString(36).slice(2),
      originalId: aditivo.id || aditivo.Id,
      tipoAditivo: aditivo.tipoAditivo || aditivo.TipoAditivo || 'Valor',
      valorAdicional: aditivo.valorAdicional || aditivo.ValorAdicional || '',
      descontoAdicional: aditivo.descontoAdicional || aditivo.DescontoAdicional || '',
      diasAdicionais: aditivo.diasAdicionais || aditivo.DiasAdicionais || '',
      alteracaoEscopo: aditivo.alteracaoEscopo || aditivo.AlteracaoEscopo || '',
      justificativa: aditivo.justificativa || aditivo.Justificativa || '',
      observacoesInternas: aditivo.observacoesInternas || aditivo.ObservacoesInternas || '',
      observacoesCliente: aditivo.observacoesCliente || aditivo.ObservacoesCliente || ''
    };
    setOpenAditivos(prev => [...prev, novo]);
  }

  async function deletarAditivo(aditivoId) {
    if (!window.confirm('Tem certeza que deseja excluir este aditivo contratual?')) {
      return;
    }

    try {
      const urls = [
        `${BASE_URL}/AditivoContratual/${aditivoId}`,
        `${BASE_URL}/AditivoContratual/${aditivoId}`,
        `${BASE_URL}/AditivoContratual/${aditivoId}`,
        `${BASE_URL}/AditivoContratual/${aditivoId}`,
        `${BASE_URL}/AditivoContratual/${aditivoId}`
      ];

      let sucesso = false;
      for (const url of urls) {
        try {
          const response = await fetch(url, { method: 'DELETE', headers: _authHeaders() });
          if (response.ok) {
            sucesso = true;
            break;
          }
        } catch (err) {
          continue;
        }
      }

      if (sucesso) {
        alert('✅ Aditivo excluído com sucesso!');
        const contratoId = contrato?.id || contrato?.Id;
        if (contratoId) {
          buscarAditivos(contratoId);
        }
      } else {
        alert('❌ Erro ao excluir aditivo.');
      }
    } catch (err) {
      alert(`Erro: ${err.message}`);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (salvando) return;
    
    setSalvando(true);
    setError('');

    // Validações
    if (descontoAdicionalInvalido) {
      setError('O desconto adicional não pode ser maior que o valor do orçamento.');
      setSalvando(false);
      return;
    }

    if (!form.Status) {
      setError('Status é obrigatório.');
      setSalvando(false);
      return;
    }

    try {
      const resultado = await onSalvar(form, null);
      
      // Verificar se o backend retornou PDF
      if (resultado && resultado.pdf) {
        console.log('📄 PDF retornado do backend');
        const contratoId = resultado.id || resultado.Id || contrato?.id || contrato?.Id;
        setContratoSalvoId(contratoId);
        
        // Converter base64 para blob se necessário
        if (typeof resultado.pdf === 'string') {
          const binaryString = atob(resultado.pdf);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          const blob = new Blob([bytes], { type: 'application/pdf' });
          setPdfBlob(blob);
        } else if (resultado.pdf instanceof Blob) {
          setPdfBlob(resultado.pdf);
        }
        
        setShowDownloadPopup(true);
      } else {
        // Se não retornou PDF, não fechará ainda (vamos processar aditivos)
      }

      // Após salvar contrato, tentar postar aditivos pendentes (se houver)
      const contratoId = resultado?.id || resultado?.Id || contrato?.id || contrato?.Id;
      if (pendingAditivos.length > 0) {
        if (!contratoId) {
          setError('Não foi possível postar aditivos: ID do contrato ausente.');
        } else {
          // Verificar se o contrato está ASSINADO no backend antes de postar
          let contratoOk = false;
          const urlsCheck = [
            `${BASE_URL}/Contrato/${contratoId}`,
            `${BASE_URL}/Contrato/${contratoId}`,
            `${BASE_URL}/Contrato/${contratoId}`,
            `${BASE_URL}/Contrato/${contratoId}`
          ];
          for (const url of urlsCheck) {
            try {
              const resp = await fetch(url, { headers: _authHeaders() });
              if (resp.ok) {
                const data = await resp.json();
                if ((data.Status || data.status) === 'Assinado' || (form.Status === 'Assinado')) {
                  contratoOk = true;
                }
                break;
              }
            } catch (e) { continue; }
          }

          if (!contratoOk) {
            setError('Aditivos só podem ser criados para contratos assinados. Confirme assinatura e tente novamente.');
          } else {
            // Postar aditivos sequencialmente
            const failures = [];
            const urlsPost = [
              `${BASE_URL}/AditivoContratual`,
              `${BASE_URL}/AditivoContratual`,
              `${BASE_URL}/AditivoContratual`,
              `${BASE_URL}/AditivoContratual`
            ];
            for (const p of pendingAditivos) {
              const payload = {
                contratoId: parseInt(contratoId),
                tipoAditivo: p.tipoAditivo,
                valorAdicional: p.valorAdicional != null ? p.valorAdicional : null,
                descontoAdicional: p.descontoAdicional != null ? p.descontoAdicional : null,
                diasAdicionais: p.diasAdicionais != null ? p.diasAdicionais : null,
                alteracaoEscopo: p.alteracaoEscopo || null,
                justificativa: p.justificativa || '',
                observacoesInternas: p.observacoesInternas || null,
                observacoesCliente: p.observacoesCliente || null
              };

              let created = false;
              for (const url of urlsPost) {
                try {
                  const resp = await fetch(url, { method: 'POST', headers: _authHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify(payload) });
                  if (resp.ok) { created = true; break; }
                } catch (e) { continue; }
              }

              if (!created) failures.push(p);
            }

            if (failures.length === 0) {
              setPendingAditivos([]);
              if (contratoId) await buscarAditivos(contratoId);
            } else {
              setError(`Falha ao criar ${failures.length} aditivo(s). Ver console para detalhes.`);
              console.error('Falhas ao criar aditivos pendentes:', failures);
            }
          }
        }
      }

      // Após tudo, se não retornou PDF, fechar o formulário
      if (!(resultado && resultado.pdf)) onCancelar();
    } catch (error) {
      console.error('Erro ao salvar contrato:', error);
      // Se o erro veio com validação do backend (400), mostrar mensagem amigável
      if (error && error.validation && error.validation.errors) {
        const parts = [];
        for (const k of Object.keys(error.validation.errors)) {
          parts.push(`${k}: ${error.validation.errors[k].join('; ')}`);
        }
        setError(`Erro de validação: ${parts.join(' | ')}`);
      } else if (error && error.message && error.message !== 'Falha ao atualizar contrato em todas as URLs') {
        // Mensagem direta do backend (ex: falha no PDF ou validação)
        setError(error.message);
      } else if (error && error.details && Array.isArray(error.details)) {
        const ultimo = error.details[error.details.length - 1];
        setError(`Erro ao salvar contrato. ${ultimo?.reason || ultimo?.message || 'Verifique o console para detalhes.'}`);
      } else {
        setError('Erro ao salvar contrato. Tente novamente. Ver console para detalhes.');
      }
    } finally {
      setSalvando(false);
    }
  }

  // Função separada para postar aditivos pendentes (usada quando contrato já está assinado)
  async function salvarAditivosPendentes() {
    if (pendingAditivos.length === 0) {
      // Ainda pode haver instâncias abertas válidas para salvar
      const validOpen = openAditivos.filter(inst => !inst.originalId && (inst.justificativa || '').trim().length >= 20);
      if (validOpen.length === 0) {
        alert('Não há aditivos pendentes ou válidos para salvar.');
        return;
      }
    }

    setSalvando(true);
    setError('');
    try {
      const contratoId = contrato?.id || contrato?.Id;
      if (!contratoId) {
        setError('ID do contrato ausente.');
        setSalvando(false);
        return;
      }

      // Verificar se o contrato está ASSINADO no backend antes de postar
      let contratoOk = false;
      const urlsCheck = [
        `${BASE_URL}/Contrato/${contratoId}`,
        `${BASE_URL}/Contrato/${contratoId}`,
        `${BASE_URL}/Contrato/${contratoId}`,
        `${BASE_URL}/Contrato/${contratoId}`
      ];
      for (const url of urlsCheck) {
        try {
          const resp = await fetch(url, { headers: _authHeaders() });
          if (resp.ok) {
            const data = await resp.json();
            if ((data.Status || data.status) === 'Assinado' || (form.Status === 'Assinado')) {
              contratoOk = true;
            }
            break;
          }
        } catch (e) { continue; }
      }

      if (!contratoOk) {
        setError('Aditivos só podem ser criados para contratos assinados. Confirme assinatura e tente novamente.');
        setSalvando(false);
        return;
      }

      // Incluir instâncias abertas válidas além dos pendentes
      const validOpen = openAditivos.filter(inst => !inst.originalId && (inst.justificativa || '').trim().length >= 20);
      const itemsToPost = [
        ...pendingAditivos,
        ...validOpen.map(inst => ({
          tipoAditivo: inst.tipoAditivo,
          valorAdicional: inst.valorAdicional != null ? (isNaN(inst.valorAdicional) ? null : parseFloat(inst.valorAdicional)) : null,
          descontoAdicional: inst.descontoAdicional != null ? (isNaN(inst.descontoAdicional) ? null : parseFloat(inst.descontoAdicional)) : null,
          diasAdicionais: inst.diasAdicionais != null ? (isNaN(inst.diasAdicionais) ? null : parseInt(inst.diasAdicionais)) : null,
          alteracaoEscopo: inst.alteracaoEscopo || null,
          justificativa: inst.justificativa || '',
          observacoesInternas: inst.observacoesInternas || null,
          observacoesCliente: inst.observacoesCliente || null
        }))
      ];

      // Postar aditivos sequencialmente
      const failures = [];
      const urlsPost = [
        `${BASE_URL}/AditivoContratual`,
        `${BASE_URL}/AditivoContratual`,
        `${BASE_URL}/AditivoContratual`,
        `${BASE_URL}/AditivoContratual`
      ];

      for (const p of itemsToPost) {
        const payload = {
          contratoId: parseInt(contratoId),
          tipoAditivo: p.tipoAditivo,
          valorAdicional: p.valorAdicional != null ? p.valorAdicional : null,
          descontoAdicional: p.descontoAdicional != null ? p.descontoAdicional : null,
          diasAdicionais: p.diasAdicionais != null ? p.diasAdicionais : null,
          alteracaoEscopo: p.alteracaoEscopo || null,
          justificativa: p.justificativa || '',
          observacoesInternas: p.observacoesInternas || null,
          observacoesCliente: p.observacoesCliente || null
        };

        let created = false;
        for (const url of urlsPost) {
          try {
            const resp = await fetch(url, { method: 'POST', headers: _authHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify(payload) });
            if (resp.ok) { created = true; break; }
          } catch (e) { continue; }
        }

        if (!created) failures.push(p);
      }

      if (failures.length === 0) {
        // Remover pendentes postados e instâncias abertas que foram incluídas
        setPendingAditivos([]);
        setOpenAditivos(prev => prev.filter(inst => inst.originalId || !(inst.justificativa || '').trim().length >= 20));
        if (contratoId) await buscarAditivos(contratoId);
        alert('Aditivos salvos com sucesso.');
      } else {
        setError(`Falha ao criar ${failures.length} aditivo(s). Ver console para detalhes.`);
        console.error('Falhas ao criar aditivos pendentes:', failures);
      }
    } catch (err) {
      console.error('Erro ao salvar aditivos pendentes:', err);
      setError('Erro ao salvar aditivos. Ver console para detalhes.');
    } finally {
      setSalvando(false);
    }
  }

  async function baixarPdfContrato() {
    try {
      let blob = pdfBlob;
      
      // Se não tiver blob em memória, buscar do backend
      if (!blob && contratoSalvoId) {
        const urls = [
          `${BASE_URL}/Contratos/${contratoSalvoId}/pdf`,
          `${BASE_URL}/Contratos/${contratoSalvoId}/pdf`,
          `${BASE_URL}/Contratos/${contratoSalvoId}/pdf`,
          `${BASE_URL}/Contratos/${contratoSalvoId}/pdf`,
          `${BASE_URL}/Contratos/${contratoSalvoId}/pdf`
        ];

        for (const url of urls) {
          try {
            const response = await fetch(url, { headers: _authHeaders() });
            if (response.ok) {
              blob = await response.blob();
              break;
            }
          } catch (err) {
            continue;
          }
        }
      }

      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Contrato_${contratoSalvoId || contrato?.id || 'novo'}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        
        // Fechar popup após download
        setShowDownloadPopup(false);
        onCancelar(); // Fecha o formulário também
      } else {
        alert('Não foi possível baixar o PDF.');
      }
    } catch (error) {
      console.error('Erro ao baixar PDF:', error);
      alert('Erro ao baixar PDF: ' + error.message);
    }
  }

  return (
    <div className="popup-overlay">
      <div className="popup-container" onClick={e => e.stopPropagation()}>
        <BotaoVoltarTopo />
        {/* Botão X para fechar */}
        <button
          onClick={onCancelar}
          className="popup-close-btn"
          aria-label="Fechar"
        >
          ×
        </button>

        <div className="popup-header">
          <h2>Editar Contrato #{contrato?.id || contrato?.Id}</h2>
        </div>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="formulario-container" id="contrato-form-geral">
          
          {/* IDs de referência */}
          <div className="form-row">
            <div className="form-group">
              <label>ID Orçamento:</label>
              <input
                type="number"
                name="OrcamentosId"
                value={form.OrcamentosId}
                onChange={handleChange}
                disabled={true}
                className="form-input disabled"
              />
            </div>
            <div className="form-group">
              <label>ID Cliente:</label>
              <input
                type="number"
                name="Id_cliente"
                value={form.Id_cliente}
                onChange={handleChange}
                disabled={true}
                className="form-input disabled"
              />
            </div>
            <div className="form-group">
              <label>ID Venda:</label>
              <input
                type="number"
                name="VendaId"
                value={form.VendaId}
                onChange={handleChange}
                disabled={true}
                className="form-input disabled"
              />
            </div>
          </div>

          {/* Status e Valor */}
          <div className="form-row" id="contrato-secao-status">
            <div className="form-group">
              <label>Status: *</label>
              <select
                name="Status"
                value={form.Status}
                onChange={handleChange}
                required
                disabled={salvando}
                className="form-input"
              >
                {statusDisponiveis.map(status => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Valor do orçamento (R$):</label>
              <input
                type="text"
                value={formatarMoeda(valorBaseContrato)}
                disabled={true}
                className="form-input disabled"
                title="O valor vem do orçamento aprovado e não pode ser alterado. Para outro valor, crie um novo orçamento."
              />
            </div>
          </div>

          {/* Desconto adicional: o valor do contrato não é editável, só pode receber desconto */}
          <div className="form-row" id="contrato-secao-desconto">
            <div className="form-group">
              <label>Desconto adicional (R$):</label>
              <input
                type="number"
                name="DescontoAdicional"
                value={form.DescontoAdicional}
                onChange={handleChange}
                step="0.01"
                min="0"
                max={valorBaseContrato}
                disabled={salvando || contratoAssinado}
                placeholder="R$ 0,00"
                className="form-input"
              />
              {descontoAdicionalInvalido && (
                <small style={{ color: '#c0392b' }}>O desconto não pode ser maior que o valor do orçamento.</small>
              )}
            </div>
            <div className="form-group">
              <label>Valor final do contrato (R$):</label>
              <input
                type="text"
                value={formatarMoeda(valorFinalContrato)}
                disabled={true}
                className="form-input disabled"
              />
            </div>
          </div>



          {/* Datas */}
          <div className="form-row" id="contrato-secao-datas">
            <div className="form-group">
              <label>Data Assinatura:</label>
              <input
                type="date"
                name="Data_assinatura"
                value={form.Data_assinatura}
                disabled={true}
                className="form-input disabled"
                title="Preenchida automaticamente no dia em que o contrato é assinado"
              />
            </div>
            <div className="form-group">
              <label>Data Vigência:</label>
              <input
                type="date"
                name="DataVigencia"
                value={form.DataVigencia}
                onChange={handleChange}
                disabled={salvando}
                className="form-input"
              />
            </div>
          </div>

          {/* Garantia e Data Criação */}
          <div className="form-row">
            <div className="form-group">
              <label>Prazo Garantia (meses):</label>
              <input
                type="number"
                name="Prazo_garantia"
                value={form.Prazo_garantia}
                onChange={handleChange}
                min="0"
                disabled={salvando}
                className="form-input"
                placeholder="Ex: 12"
              />
            </div>
            <div className="form-group">
              <label>Data Criação:</label>
              <input
                type="date"
                name="DataCriacao"
                value={form.DataCriacao}
                disabled={true}
                className="form-input disabled"
                title="A data de criação não pode ser alterada"
              />
            </div>
          </div>

          {/* Descrição do Orçamento */}
          <div className="form-group full-width" id="contrato-secao-textos">
            <label>Descrição do Orçamento:</label>
            <textarea
              name="DescricaoOrcamento"
              value={form.DescricaoOrcamento}
              onChange={handleChange}
              rows="2"
              disabled={salvando}
              className="form-textarea"
            />
          </div>

          {/* Condições de Pagamento */}
          <div className="form-group full-width">
            <label>Condições de Pagamento:</label>
            <textarea
              name="CondicoesPagto"
              value={form.CondicoesPagto}
              onChange={handleChange}
              rows="3"
              disabled={salvando}
              className="form-textarea"
            />
          </div>

          {/* Serviços Contratados */}
          <div className="form-group full-width">
            <label>Serviços Contratados:</label>
            <textarea
              name="ServicosContratados"
              value={form.ServicosContratados}
              onChange={handleChange}
              rows="4"
              disabled={salvando}
              className="form-textarea"
              placeholder="Descreva os serviços contratados..."
            />
          </div>

          {/* Aditivos Contratuais: só depois que o contrato foi assinado (antes, edita o próprio contrato) */}
          {wasSignedBefore && (
          <div id="contrato-secao-aditivos" style={{ margin: '20px 0', borderTop: '2px solid #ddd', paddingTop: '0' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', padding: '15px 0', userSelect: 'none' }}
              onClick={() => setMostrarAditivo(v => !v)}
            >
              <h3 style={{ color: 'rgb(235, 133, 0)', margin: 0 }}>
                📋 Aditivos Contratuais ({aditivos.length}{pendingAditivos.length > 0 ? ` + ${pendingAditivos.length} pendente(s)` : ''})
              </h3>
              <span style={{ fontSize: '20px', color: 'rgb(235, 133, 0)' }}>{mostrarAditivo ? '▲' : '▼'}</span>
            </div>

            {mostrarAditivo && (
              <>
                {carregandoAditivos && (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                    Carregando aditivos...
                  </div>
                )}

                {!carregandoAditivos && aditivos.length > 0 && (
                  <div style={{ marginBottom: '20px' }}>
                    {aditivos.map((aditivo, index) => (
                      <div
                        key={aditivo.id || aditivo.Id || index}
                        style={{
                          background: '#ffffff',
                          border: '1px solid #ddd',
                          borderRadius: '6px',
                          padding: '15px',
                          marginBottom: '10px',
                          display: 'grid',
                          gridTemplateColumns: '1fr auto',
                          gap: '15px',
                          alignItems: 'center'
                        }}
                      >
                        <div>
                          <div style={{ 
                            fontSize: '14px', 
                            fontWeight: 'bold', 
                            color: '#333',
                            marginBottom: '8px'
                          }}>
                            Aditivo #{aditivo.numeroAditivo || aditivo.NumeroAditivo || aditivo.id || aditivo.Id} - {aditivo.tipoAditivo || aditivo.TipoAditivo}
                            <span style={{
                              marginLeft: '10px',
                              padding: '2px 8px',
                              background: (aditivo.status || aditivo.Status) === 'Assinado' ? '#4caf50' : 'rgb(235, 133, 0)',
                              color: 'white',
                              borderRadius: '4px',
                              fontSize: '11px'
                            }}>
                              {aditivo.status || aditivo.Status}
                            </span>
                          </div>
                          
                          <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                            gap: '10px',
                            fontSize: '13px',
                            color: '#666'
                          }}>
                            {(aditivo.valorAdicional != null || aditivo.ValorAdicional != null) && (
                              <div>
                                <strong>Valor Adicional:</strong> {formatarMoeda(aditivo.valorAdicional || aditivo.ValorAdicional)}
                              </div>
                            )}
                            {(aditivo.descontoAdicional != null || aditivo.DescontoAdicional != null) && (
                              <div>
                                <strong>Desconto:</strong> {formatarMoeda(aditivo.descontoAdicional || aditivo.DescontoAdicional)}
                              </div>
                            )}
                            {(aditivo.valorFinal != null || aditivo.ValorFinal != null) && (
                              <div>
                                <strong>Valor Final:</strong> {formatarMoeda(aditivo.valorFinal || aditivo.ValorFinal)}
                              </div>
                            )}
                            {(aditivo.diasAdicionais != null || aditivo.DiasAdicionais != null) && (
                              <div>
                                <strong>Dias Adicionais:</strong> {aditivo.diasAdicionais || aditivo.DiasAdicionais}
                              </div>
                            )}
                            {(aditivo.percentualAlteracao != null || aditivo.PercentualAlteracao != null) && (
                              <div>
                                <strong>Percentual:</strong> 
                                <span style={{ 
                                  color: Math.abs(aditivo.percentualAlteracao || aditivo.PercentualAlteracao) > 25 ? '#d32f2f' : '#1976d2',
                                  fontWeight: 'bold',
                                  marginLeft: '5px'
                                }}>
                                  {(aditivo.percentualAlteracao || aditivo.PercentualAlteracao) > 0 ? '+' : ''}{(aditivo.percentualAlteracao || aditivo.PercentualAlteracao).toFixed(2)}%
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Delete button removed as requested */}
                      </div>
                    ))}
                  </div>
                )}

                {!carregandoAditivos && aditivos.length === 0 && (
                  <div style={{ 
                    textAlign: 'center', 
                    padding: '20px', 
                    color: '#999',
                    background: '#f5f5f5',
                    borderRadius: '6px',
                    marginBottom: '20px'
                  }}>
                    Nenhum aditivo contratual cadastrado ainda.
                  </div>
                )}

                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
                  <button type="button" onClick={() => addAditivoInstance()} className="aditivo-add-btn" title="Adicionar aditivo contratual">Adicionar Aditivo Contratual</button>
                </div>
              </>
            )}
          </div>
          )}
 

          {/* Instâncias múltiplas de aditivo abertas */}
          {openAditivos.length > 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 12 }}>
              {openAditivos.map(inst => (
                <div key={inst._id} style={{ position: 'relative' }}>
                  <button
                    type="button"
                    title="Remover este formulário"
                    onClick={() => removeAditivoInstance(inst._id)}
                    className="aditivo-remove-btn"
                    aria-label="Remover aditivo"
                  >
                    ×
                  </button>

                  <div style={{
                    background: '#ffffff',
                    padding: '16px',
                    borderRadius: '8px',
                    border: '1px solid #eee'
                  }}>
                    <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 8 }}>
                      <div style={{ flex: 1 }}>
                        <label style={{ color: '#000', fontWeight: '700' }}>Tipo de Aditivo:</label>
                        <select
                          value={inst.tipoAditivo}
                          onChange={(e) => handleAditivoInstanceChange(inst._id, 'tipoAditivo', e.target.value)}
                          className="form-input"
                        >
                          <option value="Valor">Aditivo de Valor</option>
                          <option value="Prazo">Aditivo de Prazo</option>
                          <option value="Escopo">Aditivo de Escopo</option>
                          <option value="Misto">Aditivo Misto (Valor + Prazo + Escopo)</option>
                        </select>
                      </div>
                      <div>
                        <button type="button" onClick={() => closeAditivoInstance(inst._id)} style={{ background: 'rgb(235, 133, 0)', color: 'white', border: 'none', padding: '8px 12px', borderRadius: 6, fontWeight: '700' }}>Fechar</button>
                      </div>
                    </div>

                    {(inst.tipoAditivo === 'Valor' || inst.tipoAditivo === 'Misto') && (
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 8 }}>
                        <div>
                          <label style={{ color: '#000' }}>Valor Adicional (R$):</label>
                          <input type="number" step="0.01" value={inst.valorAdicional} onChange={(e) => handleAditivoInstanceChange(inst._id, 'valorAdicional', e.target.value)} className="form-input" />
                        </div>
                        <div>
                          <label style={{ color: '#000' }}>Desconto Adicional (R$):</label>
                          <input type="number" step="0.01" value={inst.descontoAdicional} onChange={(e) => handleAditivoInstanceChange(inst._id, 'descontoAdicional', e.target.value)} className="form-input" />
                        </div>
                      </div>
                    )}

                    {(inst.tipoAditivo === 'Prazo' || inst.tipoAditivo === 'Misto') && (
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ color: '#000' }}>Dias Adicionais:</label>
                        <input type="number" value={inst.diasAdicionais} onChange={(e) => handleAditivoInstanceChange(inst._id, 'diasAdicionais', e.target.value)} className="form-input" />
                      </div>
                    )}

                    {(inst.tipoAditivo === 'Escopo' || inst.tipoAditivo === 'Misto') && (
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ color: '#000' }}>Descrição da Alteração de Escopo:</label>
                        <textarea value={inst.alteracaoEscopo} onChange={(e) => handleAditivoInstanceChange(inst._id, 'alteracaoEscopo', e.target.value)} rows="2" className="form-textarea" />
                      </div>
                    )}

                    <div style={{ marginBottom: 8 }}>
                      <label style={{ color: '#000', fontWeight: '700' }}>Justificativa: *</label>
                      <textarea value={inst.justificativa} onChange={(e) => handleAditivoInstanceChange(inst._id, 'justificativa', e.target.value)} rows="2" className="form-textarea" />
                      <small style={{ color: inst.justificativa.length < 20 ? '#d32f2f' : '#666' }}>{inst.justificativa.length} / 20 caracteres mínimos</small>
                    </div>
                  </div>
                </div>
              ))}

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <button type="button" onClick={addAditivoInstance} className="aditivo-add-btn" title="Adicionar outro formulário de aditivo">＋</button>
              </div>
            </div>
          )}

          {/* Pending aditivos (carrinho) */}
          {pendingAditivos.length > 0 && (
            <div style={{ marginTop: 12, border: '1px dashed rgb(250, 178, 65)', padding: 12, borderRadius: 6 }}>
              <h4 style={{ marginTop: 0, color: 'rgb(235, 133, 0)' }}>Aditivos pendentes ({pendingAditivos.length})</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {pendingAditivos.map((p) => (
                  <div key={p._tempId} style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 8, alignItems: 'center', padding: 8, background: '#ffffff', borderRadius: 6 }}>
                    <div>
                      <div style={{ fontWeight: '700' }}>{p.tipoAditivo} {p.valorAdicional ? `- ${formatarMoeda(p.valorAdicional)}` : ''}</div>
                      <div style={{ fontSize: 12, color: '#555' }}>{p.justificativa}</div>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      {/* Remove button removed from pending aditivo cards */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="form-actions">
            <button
              type="button"
              onClick={onCancelar}
              disabled={salvando}
              className="btn-secondary"
            >
              Cancelar
            </button>

            {/* Botão Refresh de Status de Assinatura */}
            {(contrato?.id || contrato?.Id) && (
              <button
                type="button"
                onClick={handleRefreshStatus}
                disabled={refreshLoading || salvando}
                className="btn-refresh"
                title="Verificar e atualizar status da assinatura"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={refreshLoading ? 'refresh-icon-spinning' : ''}
                >
                  <polyline points="23 4 23 10 17 10" />
                  <polyline points="1 20 1 14 7 14" />
                  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
                </svg>
                {refreshLoading ? 'Verificando...' : 'Refresh'}
              </button>
            )}

            {!wasSignedBefore && (contrato?.id || contrato?.Id) && (
              <button
                type="button"
                onClick={handleAssinarContrato}
                disabled={assinarLoading || salvando}
                style={{
                  padding: '10px 20px',
                  fontSize: '14px',
                  border: 'none',
                  borderRadius: '6px',
                  background: assinarLoading ? '#ccc' : 'rgb(235, 133, 0)',
                  color: 'white',
                  cursor: assinarLoading ? 'not-allowed' : 'pointer',
                  fontWeight: 'bold'
                }}
              >
                {assinarLoading ? '⏳ Gerando link...' : '✍️ Assinar Contrato'}
              </button>
            )}
            {wasSignedBefore ? (
              (() => {
                const validOpen = openAditivos.filter(inst => !inst.originalId && (inst.justificativa || '').trim().length >= 20);
                const total = pendingAditivos.length + validOpen.length;
                return (
                  <button
                    type="button"
                    onClick={salvarAditivosPendentes}
                    disabled={salvando || total === 0}
                    className="btn-primary"
                  >
                    {salvando ? 'Salvando...' : `Salvar Aditivos (${total})`}
                  </button>
                );
              })()
            ) : (
              <button
                type="submit"
                disabled={salvando}
                className="btn-primary"
              >
                {salvando ? 'Salvando...' : 'Salvar Contrato'}
              </button>
            )}
          </div>

          {/* Aviso de refresh manual após assinatura */}
          {(contrato?.id || contrato?.Id) && form.Status !== 'Assinado' && (
            <p style={{
              color: '#c62828',
              fontSize: 12,
              marginTop: 6,
              textAlign: 'right',
              lineHeight: 1.4
            }}>
              Caso o contrato não atualize automaticamente após a assinatura do cliente,
              clique em <strong>Refresh</strong> e aguarde — o sistema irá gerar o novo PDF
              com a assinatura e atualizar o status para <strong>Assinado</strong>.
            </p>
          )}
        </form>
      </div>

      {/* MODAL: Link de assinatura Assinafy */}
      {showLinkModal && assinaturaResult && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: 'rgba(0,0,0,0.5)', zIndex: 100002,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 16,
            boxShadow: '0 8px 32px 0 rgba(0,0,0,0.2)',
            padding: 32, minWidth: 320, maxWidth: 560, width: '90vw',
            display: 'flex', flexDirection: 'column', alignItems: 'center'
          }}>
            <h3 style={{ color: 'rgb(235, 133, 0)', marginBottom: 8 }}>✍️ Assinatura digital</h3>
            <p style={{ textAlign: 'center', marginBottom: 16, color: '#555' }}>
              O navegador bloqueou a abertura automática da nova aba. Clique no botão para abrir a página de assinatura.
            </p>
            <a
              href={assinaturaResult.link}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setShowLinkModal(false)}
              style={{
                padding: '12px 24px', borderRadius: 6, background: 'rgb(235, 133, 0)',
                color: 'white', fontWeight: 'bold', textDecoration: 'none'
              }}
            >
              Abrir página de assinatura
            </a>
            <button
              onClick={() => setShowLinkModal(false)}
              style={{
                marginTop: 16, padding: '10px 24px', border: '1px solid #ddd',
                borderRadius: 6, background: 'white', color: '#333',
                cursor: 'pointer', fontWeight: 'bold'
              }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      {/* POPUP: Status de assinatura */}
      {statusPopup && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: 'rgba(0,0,0,0.5)', zIndex: 100010,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 16,
            boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
            padding: 36, minWidth: 300, maxWidth: 460, width: '90vw',
            display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'
          }}>
            <div style={{
              fontSize: 48, marginBottom: 12,
              color: statusPopup.type === 'success' ? '#4caf50' : statusPopup.type === 'error' ? '#e53935' : 'rgb(235, 133, 0)'
            }}>
              {statusPopup.type === 'success' ? '✅' : statusPopup.type === 'error' ? '❌' : 'ℹ️'}
            </div>
            <h3 style={{
              margin: '0 0 12px',
              color: statusPopup.type === 'success' ? '#4caf50' : statusPopup.type === 'error' ? '#e53935' : 'rgb(235, 133, 0)',
              fontSize: 20
            }}>
              {statusPopup.title}
            </h3>
            <p style={{ color: '#555', fontSize: 15, margin: '0 0 24px', lineHeight: 1.5 }}>
              {statusPopup.text}
            </p>
            <button
              onClick={() => setStatusPopup(null)}
              style={{
                padding: '10px 32px', border: 'none', borderRadius: 8,
                background: statusPopup.type === 'success' ? '#4caf50' : statusPopup.type === 'error' ? '#e53935' : 'rgb(235, 133, 0)',
                color: '#fff', fontWeight: 'bold', fontSize: 15, cursor: 'pointer'
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* POPUP: Download de PDF após salvar contrato */}
      {showDownloadPopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.5)',
          zIndex: 100002,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff',
            borderRadius: 16,
            boxShadow: '0 8px 32px 0 rgba(0,0,0,0.2)',
            padding: 32,
            minWidth: 300,
            maxWidth: 540,
            width: '90vw',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <h3 style={{ color: 'rgb(235, 133, 0)', marginBottom: 8 }}>✅ Contrato salvo com sucesso!</h3>
            <p style={{ textAlign: 'center', marginBottom: 20 }}>
              Deseja baixar o PDF do contrato agora?
            </p>
            <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
              <button 
                onClick={async () => await baixarPdfContrato()}
                style={{
                  padding: '10px 20px',
                  fontSize: '14px',
                  border: 'none',
                  borderRadius: '6px',
                  background: 'rgb(235, 133, 0)',
                  color: 'white',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
                onMouseEnter={(e) => e.target.style.background = 'rgb(208, 116, 0)'}
                onMouseLeave={(e) => e.target.style.background = 'rgb(235, 133, 0)'}
              >
                📥 Baixar PDF
              </button>
              <button 
                onClick={() => {
                  setShowDownloadPopup(false);
                  onCancelar();
                }}
                style={{
                  padding: '10px 20px',
                  fontSize: '14px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  background: 'white',
                  color: '#333',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
                onMouseEnter={(e) => e.target.style.background = '#f5f5f5'}
                onMouseLeave={(e) => e.target.style.background = 'white'}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
